import { Checkbox, Link, TableCell, TableRow } from '@amzn/meridian';
import type {
  UsersTableRowProjectDataFragment,
  UsersTableRowUserDataFragment,
  UsersTableRowUserPermissionDataFragment,
} from 'generated/graphql';
import type { FC } from 'react';
import { PermissionTablePermissionActionCell } from './cells/PermissionTablePermissionActionCell';
import { UsersPermissionTableAliasCell } from './cells/UsersPermissionTableAliasCell';
import { UsersPermissionTableNameCell } from './cells/UsersPermissionTableNameCell';

export type UsersPermissionTableRowProps = {
  userData: UsersTableRowUserDataFragment;
  permissionData: UsersTableRowUserPermissionDataFragment;
  projectData: UsersTableRowProjectDataFragment;
  isRemovable: boolean;
  onChangeRow: (value: boolean) => void;
  selected: (alias: UsersTableRowUserDataFragment['alias']) => void;
  onRemove: (person: UsersTableRowUserDataFragment) => void;
};

export const UsersPermissionTableRow: FC<UsersPermissionTableRowProps> = ({
  userData,
  onChangeRow,
  selected,
  onRemove,
  permissionData,
  projectData,
  isRemovable,
}) => (
  <TableRow key={`${userData.alias}-${userData.firstName}-${userData.lastName}`}>
    <TableCell>
      <Checkbox checked={selected(userData.alias)} disabled={!isRemovable} onChange={onChangeRow} />
    </TableCell>
    <UsersPermissionTableNameCell user={userData} />
    <UsersPermissionTableAliasCell user={userData} />
    <PermissionTablePermissionActionCell permissionData={permissionData} projectData={projectData} userData={userData} />
    <TableCell>
      {isRemovable ? (
        <Link onClick={() => onRemove(userData)} type="secondary">
          Remove
        </Link>
      ) : null}
    </TableCell>
  </TableRow>
);
